export default __webpack_public_path__ + "static/media/Tasset of the Martial Paragon.05686287.jpg";